module.exports = __webpack_public_path__ + "static/media/writech.95c35ece.png";